import React, { Component } from 'react';
import { ButtonToolbar, Button, MenuItem, DropdownButton } from 'react-bootstrap';
import '../../content/css/FilterControl.css';

export default class PortfolioAnalysisFilterControl extends Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            //this.setState({ filter: [...this.state.filter, event.target.value] });
            event.target.value = '';
        };
    }

    handleContractTypeFilterClick = (contractType) => {
        this.handleContractTypeSelect(contractType);
    }

    handleConceptGroupFilterClick = (conceptGroup) => {
        this.handleConceptGroupSelect(conceptGroup);
    }

    updateFilter = (filter) => {
        this.props.onChange(filter);
    }

    filterHasContractType = (contractType) => {
        return this.props.filter.contractTypes.includes(contractType);
    }

    handleContractTypeSelect = (contractType) => {
        let filter = { ...this.props.filter };
        let shouldAdd = !filter.contractTypes.includes(contractType);
        if (shouldAdd)
            filter.contractTypes = [...new Set([...filter.contractTypes, contractType])];
        else
            filter.contractTypes = filter.contractTypes.filter(x => x !== contractType);

        this.updateFilter(filter);
    }

    handleConceptGroupSelect = (conceptGroup) => {
        let filter = { ...this.props.filter };
        let shouldAdd = !filter.conceptGroups.includes(conceptGroup);
        if (shouldAdd)
            filter.conceptGroups = [...new Set([...filter.conceptGroups, conceptGroup])];
        else
            filter.conceptGroups = filter.conceptGroups.filter(x => x !== conceptGroup);

        this.updateFilter(filter);
    }

    renderFilters = () => {
        if (this.props.filter.length === 0) return [];

        let filterButtons = [];

        let contractTypes = this.props.filter.contractTypes;
        filterButtons = contractTypes.map((filter, i) => (
            <Button bsSize="xsmall" onClick={() => this.handleContractTypeFilterClick(filter)}>{filter}</Button>
        ));

        let conceptGroups = this.props.filter.conceptGroups;
        filterButtons = filterButtons.concat(conceptGroups.map((filter, i) => (
            <Button bsSize="xsmall" onClick={() => this.handleConceptGroupFilterClick(filter)}>{filter}</Button>
        )));

        return filterButtons;
    }

    renderContractTypes = () => {
        if (this.props.contractTypes == null) return [];

        return this.props.contractTypes.map(x => (
            <MenuItem eventKey="1" onSelect={() => this.handleSelect(x)}>{x}</MenuItem>
        ));
    }

    render() {
        return (
            <div className="filter-control">
                {/*<input type="search" id="filter-search" name="q" onKeyPress={this.handleKeyPress} />*/}
                {/*<div className="contract-type-dropdown">
                    <DropdownButton title="Contract type" id={`dropdown-contract-type`} >
                        <MenuItem eventKey="1" active={this.filterHasContractType("ProcurementAgreement")} onSelect={() => this.handleContractTypeSelect("ProcurementAgreement")}>ProcurementAgreement</MenuItem>
                        <MenuItem eventKey="2" active={this.filterHasContractType("CustomerAgreement")} onSelect={() => this.handleContractTypeSelect("CustomerAgreement")}>CustomerAgreement</MenuItem>
                        <MenuItem eventKey="4" active={this.filterHasContractType("NDA_Customer")} onSelect={() => this.handleContractTypeSelect("NDA_Customer")}>NDA_Customer</MenuItem>
                        <MenuItem eventKey="5" active={this.filterHasContractType("NDA_Seller")} onSelect={() => this.handleContractTypeSelect("NDA_Seller")}>NDA_Seller</MenuItem>
                        <MenuItem eventKey="6" active={this.filterHasContractType("NDA_Mutual")} onSelect={() => this.handleContractTypeSelect("NDA_Mutual")}>NDA_Mutual</MenuItem>
                        <MenuItem eventKey="7" active={this.filterHasContractType("EULA_Seller")} onSelect={() => this.handleContractTypeSelect("EULA_Seller")}>EULA_Seller</MenuItem>
                        <MenuItem eventKey="8" active={this.filterHasContractType("EULA_Customer")} onSelect={() => this.handleContractTypeSelect("EULA_Customer")}>EULA_Customer</MenuItem>
                        <MenuItem eventKey="9" active={this.filterHasContractType("DistributionAgreement_Customer")} onSelect={() => this.handleContractTypeSelect("DistributionAgreement_Customer")}>DistributionAgreement_Customer</MenuItem>
                        <MenuItem eventKey="10" active={this.filterHasContractType("DistributionAgreement_Seller")} onSelect={() => this.handleContractTypeSelect("DistributionAgreement_Seller")}>DistributionAgreement_Seller</MenuItem>
                        <MenuItem eventKey="11" active={this.filterHasContractType("LicenseAgreement_Customer")} onSelect={() => this.handleContractTypeSelect("LicenseAgreement_Customer")}>LicenseAgreement_Customer</MenuItem>
                        <MenuItem eventKey="12" active={this.filterHasContractType("LicenseAgreement_Seller")} onSelect={() => this.handleContractTypeSelect("LicenseAgreement_Seller")}>LicenseAgreement_Seller</MenuItem>
                        <MenuItem eventKey="13" active={this.filterHasContractType("DPA_Controller")} onSelect={() => this.handleContractTypeSelect("DPA_Controller")}>DPA_Controller</MenuItem>
                        <MenuItem eventKey="14" active={this.filterHasContractType("DPA_Processor")} onSelect={() => this.handleContractTypeSelect("DPA_Processor")}>DPA_Processor</MenuItem>
                        <MenuItem eventKey="15" active={this.filterHasContractType("SourcingOfGoods_Customer")} onSelect={() => this.handleContractTypeSelect("SourcingOfGoods_Customer")}>SourcingOfGoods_Customer</MenuItem>
                        <MenuItem eventKey="15" active={this.filterHasContractType("Services_Customer")} onSelect={() => this.handleContractTypeSelect("Services_Customer")}>Services_Customer</MenuItem>
                        <MenuItem eventKey="15" active={this.filterHasContractType("Services_Seller")} onSelect={() => this.handleContractTypeSelect("Services_Seller")}>Services_Seller</MenuItem>
                        <MenuItem eventKey="3" active={this.filterHasContractType("Unknown")} onSelect={() => this.handleContractTypeSelect("Unknown")}>Unknown</MenuItem>
                    </DropdownButton>
                </div>*/}
                {/*<ButtonToolbar className="filter-toolbar">
                    {this.renderFilters()}
                </ButtonToolbar>
                */}
                <Button className="show-filter-panel-btn" onClick={this.props.onTogglePanel}>Filters</Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AnalysisReports/PortfolioAnalysisFilterControl.js